import { FC, useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { highRiskSupplementSearchIsLoadingSelector } from '@store/features/highRiskSupplementsSearch/selectors';
import {
  removeHighRiskSupplementsSearch,
  saveSearchValue,
} from '@store/features/highRiskSupplementsSearch/slice';
import useDispatch from '@store/hooks/useDispatch';

import HRSSearchInput from '../HRSSearchInput/HRSSearchInput';

import './style.scss';

interface IProps {
  title: string;
  onSearch: (value: string) => void;
  onKeyDown: (event: React.SyntheticEvent) => void;
}

const HRSSearch: FC<IProps> = ({ title, onSearch, onKeyDown }): JSX.Element => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [searchValue, setSearchValue] = useState('');
  const isLoading = useSelector(highRiskSupplementSearchIsLoadingSelector);

  const handleChange = useCallback(
    (value: string) => {
      dispatch(removeHighRiskSupplementsSearch());
      setSearchValue(value);
    },
    [dispatch],
  );

  const handleSearch = useCallback(
    (value: string) => {
      dispatch(saveSearchValue(value));
      onSearch(value);
    },
    [onSearch],
  );

  useEffect(() => {
    dispatch(removeHighRiskSupplementsSearch());
  }, [dispatch]);

  useEffect(() => {
    handleSearch(searchValue);
  }, [searchValue]);

  return (
    <HRSSearchInput
      className="hrs-search__select"
      title={title}
      placeholder={t('highRiskSupplements.searchHint')}
      showTitle={false}
      isLoading={isLoading}
      searchValue={searchValue}
      onSearch={handleChange}
      onKeyDown={onKeyDown}
    />
  );
};

export default HRSSearch;
